import { render, staticRenderFns } from "./LightUgTableCell.vue?vue&type=template&id=7372bda8&scoped=true"
import script from "./LightUgTableCell.vue?vue&type=script&lang=ts"
export * from "./LightUgTableCell.vue?vue&type=script&lang=ts"
import style0 from "./LightUgTableCell.vue?vue&type=style&index=0&id=7372bda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7372bda8",
  null
  
)

export default component.exports